
import { defineComponent } from "vue";

import { usePilotList } from "@/hooks";

import { nameToURL } from "@/helpers";

import Card from "@/components/Pilots/Card.vue";

export default defineComponent({
  name: "PilotsView",
  setup() {
    const pilots = usePilotList();

    const getPilotUrl = (name: string) => {
      return `/pilots/${nameToURL(name)}`;
    };

    return { pilots, getPilotUrl };
  },
  components: {
    Card,
  },
});
